var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheese(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316.811 32.668C313.721 32.221 310.627 32 307.551 32C293.381 32 279.574 36.684 268.227 45.512L12.244 246.398C4.514 252.465 0 261.746 0 271.572V432C0 458.51 21.49 480 48 480H464C490.51 480 512 458.51 512 432V256C512 82.297 377.301 41.426 316.811 32.668ZM278.051 58.141C286.58 51.506 296.779 48 307.551 48C309.865 48 312.193 48.166 314.518 48.502C369.084 56.402 496 92.436 496 256H25.926L278.051 58.141ZM464 464H48C30.355 464 16 449.645 16 432V272H496V432C496 449.645 481.645 464 464 464Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheese);
export default __webpack_public_path__ + "static/media/cheese.572c8d09aae2d0be0e865c6082e5f81f.svg";
export { ForwardRef as ReactComponent };